import snakeCase from 'lodash/snakeCase';
import {useContext} from 'react';
import {getKeys} from '../../common/util/object';
import {
  ISendEventParam,
  ISendViewImpParam,
  sendEvent,
  sendViewImp,
} from '../../common/util/tracking';
import {CommentTrackingContext} from '../common';

export default function useCommentEvent(page?: string) {
  const {
    section,
    page: contextPage,
    ...props
  } = useContext(CommentTrackingContext);

  const sendCommentEvent = ({
    actionName,
    action,
    customProps,
  }: Pick<ISendEventParam, 'actionName' | 'action' | 'customProps'>) => {
    sendEvent({
      section,
      page: page ?? contextPage,
      actionName,
      action,
      customProps: {
        ...customProps,
        ...getKeys(props).reduce((acc, key) => {
          acc[snakeCase(key)] = props[key];
          return acc;
        }, {} as any),
      },
    });
  };

  const sendCommentViewImp = ({
    customProps,
    viewImpContents,
  }: Pick<ISendViewImpParam, 'customProps' | 'viewImpContents'>) => {
    sendViewImp({
      section,
      page: page ?? contextPage,
      customProps: {
        ...customProps,
        ...getKeys(props).reduce((acc, key) => {
          acc[snakeCase(key)] = props[key];
          return acc;
        }, {} as any),
      },
      viewImpContents,
    });
  };

  return {sendCommentEvent, sendCommentViewImp};
}
